import React from "react";
import { ReactNode } from "react";

type SelectValue = string | number;

export default function Select<T> (props: {value: T | undefined, children: ReactNode, onChange: (value: T) => void, label: string, onBlur?: ()=>void}){
  return (
    <div className={"select-input"}>
      <select 
          role="select"
          tabIndex={0}
          aria-label={props.label}
          aria-valuenow={props.value}
          className="select-input__input" 
          value={props.value as SelectValue} 
          onChange={(e)=> props.onChange(e.target.value as T)}
          onBlur={props.onBlur}
        >
        {React.Children.map(props.children, (child) => {
          if (React.isValidElement(child) && child.props.value !== undefined) {
            return React.cloneElement(child, {
              "tabIndex": 0,
              "role": "option",
              "aria-selected": child.props.value === props.value,
            });
          }
          return child;
        })}
      </select> 
    </div>
    );
}